import React, { useEffect, useCallback, useState} from 'react';
import ReactBootstrapSlider from 'react-bootstrap-slider';
import {connect} from 'react-redux';

const PSlider = ({onMouseUp, value, root, onUpdateParameter, step, max, min}) => { 
    return (
         <ReactBootstrapSlider
           slideStop={onMouseUp}
           value={pow(parseFloat(value), 1.0/root)}
           change={onUpdateParameter}
           step={step}
           max={max}
           min={min}
           orientation="horizontal"
           reversed={false}
         />
    );
}

const mapStateToProps = (state, props) => {
    let val = state.effects.effectParameters[props.parameter.id];
    return {
        value: val === undefined ? props.parameter.get(true) : val,
    };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

const pow = (a,b) =>
      a < 0 ? -1 * Math.pow(Math.abs(a), b) :
      Math.pow(a,b);
export default connect(mapStateToProps, mapDispatchToProps)(PSlider);
